<aside
  class="navigation-drawer"
  [class.navigation-drawer--left]="!alignRight()"
  [class.navigation-drawer--right]="alignRight()"
  [class.navigation-drawer--overlay]="overlay()"
  [class.navigation-drawer--floating-sub-menu]="floatingSubMenu()"
  [class.navigation-drawer--dark]="dark()"
  [@slide]="{
    value: slideAnimationState(),
    params: { offset: widthWide }
  }"
  [@collapseX]="{
    value: collapseState(),
    params: { width: collapseWidth() }
  }"
  [elevation]="elevationLevel()"
  appElevation
>
  <div
    class="navigation-drawer__scroll-container-inner"
    [class.navigation-drawer__scroll-container-inner--no-bottom-spacing]="
      showNarrowToggleContainer()
    "
  >
    @if (mobileView()) {
      <button
        im-icon-button
        class="navigation-drawer__close"
        [attr.aria-label]="'general.close_a' | translate"
        (click)="onCloseClick()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        >
          <path d="M18 6 6 18M6 6l12 12" />
        </svg>
      </button>
    }

    <div
      #header
      class="navigation-drawer__header"
      [class.navigation-drawer__header--visible]="
        drawerNarrow() === false && header.children.length
      "
      [@innerFade]="innerFadeState()"
    >
      <ng-content select="header"></ng-content>
    </div>

    <app-navigation-drawer-list
      class="navigation-drawer__list"
      [items]="items()"
      [@innerFade]="innerFadeState()"
    >
    </app-navigation-drawer-list>

    <div
      #footer
      class="navigation-drawer__footer"
      [class.navigation-drawer__footer--visible]="
        drawerNarrow() === false && footer.children.length
      "
      [@innerFade]="innerFadeState()"
    >
      <ng-content select="footer"></ng-content>
    </div>
  </div>

  @if (showNarrowToggleContainer()) {
    <div class="navigation-drawer__narrow-toggle-container">
      <app-navigation-drawer-list [@innerFade]="innerFadeState()">
        <app-navigation-drawer-item
          [item]="narrowToggleItem()"
          [narrow]="drawerNarrow()"
          [noTextWrap]="true"
          (clickEvent)="onNarrowToggleClick(drawerNarrow())"
        ></app-navigation-drawer-item>
      </app-navigation-drawer-list>
    </div>
  }
</aside>
